import * as React from 'react';
import { routeForDevices } from '../Routes';
import { iconLight } from '../Styles/Colours';
import styles from './BreadCrumbs.module.scss';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';
import { ArrowRightIcon, HomeIcon } from './Icons';

export type BreadCrumb = {
    route: string;
    title: string;
};

export const BreadCrumbs: React.FC<{ trail?: BreadCrumb[] }> = props => {
    const history = useHistory();
    function clickCrumbHandler(route: string) {
        history.push(route);
    }

    return (
        <div className={styles.container}>
            <span className={styles.breadcrumbLink} onClick={() => clickCrumbHandler(routeForDevices)}>
                <HomeIcon color={iconLight} size='18' />
            </span>
            {!!props.trail &&
                props.trail.length &&
                props.trail.map((breadcrumb, index) => {
                    const ancestor = !!props.trail && props.trail.length > index + 1;
                    const breadcrumbClasses = classNames(styles.breadcrumbLink, { [styles.ancestor]: ancestor });
                    return (
                        <span className={styles.breadcrumb} key={index}>
                            <span className={styles.breadcrumbIndicator}>
                                <ArrowRightIcon color={iconLight} size='12' />
                            </span>
                            <span className={breadcrumbClasses} onClick={() => clickCrumbHandler(breadcrumb.route)}>
                                {breadcrumb.title}
                            </span>
                        </span>
                    );
                })}
        </div>
    );
};
